import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DeleteAccountDialogComponent } from './delete-account-dialog.component';

import { Account } from '../models/account.model';

@Injectable()
export class DeleteAccountDialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(account: Account) {
    return this.dialog.open(DeleteAccountDialogComponent, {
      data: {
        account,
      },
      width: '95vw',
      maxWidth: '500px',
    });
  }
}
